var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeNone = function SvgVolumeNone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 13.4-1.9 1.9a.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275.95.95 0 0 1-.275-.7q0-.425.275-.7l1.9-1.9-1.9-1.9a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275l1.9 1.9 1.9-1.9a.95.95 0 0 1 .7-.275q.425 0 .7.275a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L19.4 12l1.9 1.9a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275zM7 15H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 14v-4q0-.424.288-.713A.97.97 0 0 1 4 9h3l3.3-3.3q.476-.476 1.087-.213.613.263.613.938v11.15q0 .674-.613.938-.612.262-1.087-.213z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeNone);
export { ForwardRef as ReactComponent };